module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/003-austria-2af74bd05443648f399c71ce3544ee9b.svg";